import { render, staticRenderFns } from "./EndorsementEdit.vue?vue&type=template&id=08c0122c&"
import script from "./EndorsementEdit.vue?vue&type=script&lang=js&"
export * from "./EndorsementEdit.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports